import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import InputSearch from "../../../components/inputs/inputSearch/inputSearch";
import InputDropdown from "../../../components/inputs/inputDropdown/inputDropdown";
import InputDropdownAdd from "../../../components/inputs/inputDropdownAdd/inputDropdownAdd";
import Table from "../../../components/table/table";
import Notification from "../../../components/notification/notification";
import Button from "../../../components/button/button";
import Modal from "../../../components/modal/modal";
import Input from "../../../components/inputs/input/input";
import Badge from "../../../components/badge/badge";
import { IoCloudUpload } from "react-icons/io5";
import { getApiInstance } from "../../../utils/api";
import "./presupuestosProveedor.scss";
import TableEditable from "../../../components/tableEditable/tableEditable";
import FileList from "../../../components/fileList/fileList";
import { PiWarning } from "react-icons/pi";
import { IoMdClose } from "react-icons/io";
import { FiFilter } from "react-icons/fi";
import Accordion from "../../../components/accordion/accordion";
import { matchesSearchInObject } from "../../../utils/searchUtils";
import Tag from "../../../components/tag/tag";
import Popup from "../../../components/popup/popup";

export default function PresupuestosProveedor({ user }) {
    const location = useLocation();
    
    // Estado para el popup de decisión de duplicadas
    const [isConfirmPopupOpen, setIsConfirmPopupOpen] = useState(false);
    const [importConfirmData, setImportConfirmData] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    // Estado para el modal de duplicadas en Excel
    const [duplicadasModalOpen, setDuplicadasModalOpen] = useState(false);
    const [duplicadasModalData, setDuplicadasModalData] = useState([]);
    const [presupuestos, setPresupuestos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [tiendasOptions, setTiendasOptions] = useState([]);
    const [tiendasRaw, setTiendasRaw] = useState([]); // raw response from /tiendas
    const [selectedTienda, setSelectedTienda] = useState("");
    const notificationRef = useRef();
    const api = getApiInstance();

    const [isImportModalOpen, setIsImportModalOpen] = useState(false);
    const [importFile, setImportFile] = useState(null);
    const [importNombreTarifa, setImportNombreTarifa] = useState("");
    const [isImporting, setIsImporting] = useState(false);

    // Nuevo: vistas toggles e importaciones pendientes
    const [viewMode, setViewMode] = useState("importaciones"); // 'presupuestos' | 'importaciones'
    const [importaciones, setImportaciones] = useState([]);
    // Nuevo: importaciones filtradas por tienda
    const [filteredImportacionesByTienda, setFilteredImportacionesByTienda] =
        useState([]);
    const [importsLoading, setImportsLoading] = useState(false);

    // modal detalle para importación / presupuesto
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const [detailTitulo, setDetailTitulo] = useState("");
    const [detailContenido, setDetailContenido] = useState(null);
    const [isDetailPresupuestoModalOpen, setIsDetailPresupuestoModalOpen] =
        useState(false);
    const [detailPresupuestoTitulo, setDetailPresupuestoTitulo] = useState("");
    const [detailPresupuestoContenido, setDetailPresupuestoContenido] =
        useState(null);
    const [isGenerating, setIsGenerating] = useState(false);
    const [currentImportId, setCurrentImportId] = useState(null); // id de la importación abierta en detalle
    const [tarifas, setTarifas] = useState([]);
    const [seleccionados, setSeleccionados] = useState();

    const [presupuestosAprobados, setPresupuestosAprobados] = useState([]);
    const [loadingAprobados, setLoadingAprobados] = useState(false);
    const [presupuestoGOI, setPresupuestoGOI] = useState("");
    const [presupuestosAbiertos, setPresupuestosAbiertos] = useState([]);
    const [selectedTiendaModal, setSelectedTiendaModal] = useState("");

    // Estados para el modal de filtros
    const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
    const [filterProveedores, setFilterProveedores] = useState([]);
    const [filterTiendasCerradas, setFilterTiendasCerradas] = useState(false);
    const [proveedoresDisponibles, setProveedoresDisponibles] = useState([]);
    const [filterEstados, setFilterEstados] = useState([]);
    const [estadosDisponibles, setEstadosDisponibles] = useState([]);
    const [filterTiendasAbiertas, setFilterTiendasAbiertas] = useState(false);
    
    // Estados para el popup de confirmación de eliminación
    const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
    const [deleteImportId, setDeleteImportId] = useState(null);

    const [tiendasAbiertas, setTiendasAbiertas] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);


    const formatDate = (value) => {
        if (!value) return "";
        const d = new Date(value);
        if (isNaN(d.getTime())) return String(value);
        return d.toLocaleDateString("es-ES", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
    };

    const formatNumber = (value) => {
        if (value === null || value === undefined || value === "") return "";
        const n = Number(value);
        if (isNaN(n)) return String(value);
        return n.toLocaleString();
    };

    const fetchSendNotificationAprobacion = async (idImportacion, nombrePresupuesto, codigoTienda) => {
        try {
            const formData = new FormData();

            // Obtener información de la tienda si está disponible
            const tiendaInfo = tiendasOptions.find(t => 
                String(t.value) === String(codigoTienda) || 
                String(t.tienda?.CodTienda) === String(codigoTienda)
            );
            const tiendaNombre = tiendaInfo ? tiendaInfo.label : `Tienda ${codigoTienda}`;

            // Crear mensaje detallado
            const mensaje = `Su presupuesto "${nombrePresupuesto || 'Sin nombre'}" ha sido aprobado para la tienda ${tiendaNombre}.`;
            
            // Crear título con información del presupuesto y tienda
            const titulo = `Presupuesto aprobado - ${nombrePresupuesto || 'Sin nombre'} (${tiendaNombre})`;

            // Tipos destinatarios: 4 = AdminProveedores
            formData.append("DestinatariosNotificacion", 4);
            formData.append("CodUsuarioNotifica", user.codUsuario);
            formData.append("Mensaje", mensaje);
            formData.append("Titulo", titulo);
            formData.append("TipoNotificacion", 0); // Info
            
            // Enlace para navegar al presupuesto aprobado
            const enlace = `/admin/presupuestos?activeTab=presupuestosProveedor&view=aprobados&importacion=${idImportacion}`;
            formData.append("Enlace", enlace);

            await api.post(`/api/Notificaciones`, formData);
        } catch (error) {
            console.error("Error enviando notificación de aprobación:", error);
        }
    };

    const estadoLabels = {
        1: "Coincidente",
        2: "No coincidente",
        3: "No encontrado",
        4: "Sin precio Book",
    };

    const estadoVariant = (e) => {
        switch (Number(e)) {
            case 1:
                return "success"; // verde
            case 2:
                return "danger"; // rojo/naranja (No coincidente)
            case 3:
                return "info"; // azul/neutral (No encontrado)
            case 4:
                return "warning"; // amarillo (Sin precio)
            default:
                return "default";
        }
    };

    // Sólo detalle con estado "No encontrado" (3) y que no esté aprobado fuera de Book ni como especial
    const detalleNoEncontrado = useMemo(() => {
        const det = detailContenido?.detalle;
        if (!Array.isArray(det)) return [];
        return det.filter((r) => {
            const estado = Number(r.estado ?? r.Estado ?? 0);
            const aprobado =
                !!(r.aprobadoEspecial ?? r.AprobadoEspecial) ||
                !!(r.aprobadoFueraDeBook ?? r.AprobadoFueraDeBook);
            return estado === 3 && !aprobado;
        });
    }, [detailContenido]);

    // carga opciones de tiendas desde /api/Presupuestos/tiendas
    const fetchTiendas = async () => {
        try {
            const res = await api.get("/api/Presupuestos/tiendas");
            if (res && res.status === 200 && Array.isArray(res.data)) {
                setTiendasRaw(res.data);
                const opts = res.data.map((t) => ({
                    label: `${t.codigo ?? t.Codigo ?? ""} - ${
                        t.cadena ?? t.Cadena ?? ""
                    } ${
                        t.ciudad || t.pais
                            ? `(${[t.ciudad, t.pais]
                                  .filter(Boolean)
                                  .join(", ")})`
                            : ""
                    } ${t.fechaCierre ? "(C)" : ""}`.trim(),
                    value:
                        t.codTienda ??
                        t.CodTienda ??
                        t.codigo ??
                        t.Codigo ??
                        "",
                }));
                setTiendasOptions(opts);
            } else {
                setTiendasOptions([]);
                setTiendasRaw([]);
            }
        } catch (err) {
            console.error("Error cargando tiendas:", err);
            setTiendasOptions([]);
            setTiendasRaw([]);
        }
    };

    const fetchPresupuestos = async (tiendaValue = "") => {
        try {
            setLoading(true);
            const basePaths = [
                "/api/Presupuestos/presupuestos",
                "/api/Presupuestos/presupuestos-por-proveedor",
            ];
            let res = null;
            for (const p of basePaths) {
                const path = tiendaValue
                    ? `${p}?codTienda=${encodeURIComponent(tiendaValue)}`
                    : p;
                try {
                    res = await api.get(path);
                    if (res && res.status === 200) break;
                } catch (err) {
                    // intentar siguiente ruta
                }
            }
            if (res && res.status === 200 && Array.isArray(res.data)) {
                setPresupuestos(res.data);
            } else {
                setPresupuestos([]);
            }
        } catch (err) {
            console.error("Error fetching presupuestos:", err);
            notificationRef.current?.addNotification(
                "Error cargando presupuestos.",
                "error"
            );
            setPresupuestos([]);
        } finally {
            setLoading(false);
        }
    };
    // Nuevo: obtener importaciones pendientes
    const fetchImportacionesPendientes = async () => {
        try {
            setImportsLoading(true);
            // Determinar endpoint según tipo de empresa
            const codTipoEmpresaRaw =
                user?.CodTipoEmpresa ??
                user?.codTipoEmpresa ??
                user?.empresa?.CodTipoEmpresa ??
                user?.empresa?.codTipoEmpresa ??
                null;
            const codTipoEmpresa = Number(codTipoEmpresaRaw);

            let endpoint = "";
            let params = { tipo: "Presupuesto", cerrada: false };
            if (codTipoEmpresa === 1 || codTipoEmpresa === 2) {
                endpoint = "/api/GOI/Importaciones/Global";
            } else if (codTipoEmpresa === 3) {
                endpoint = "/api/GOI/Importaciones/Global/Proveedor";
            } else {
                endpoint = "/api/GOI/Importaciones/Global/Proveedor";
            }

            const res = await api.get(endpoint, { params });
            if (res && res.status === 200 && Array.isArray(res.data)) {
                setImportaciones(res.data);
                // Filtrar por tienda si hay una seleccionada
                if (selectedTienda) {
                    setFilteredImportacionesByTienda(
                        res.data.filter(
                            (item) =>
                                String(item.codTienda) ===
                                String(selectedTienda)
                        )
                    );
                } else {
                    setFilteredImportacionesByTienda(res.data);
                }
            } else {
                setImportaciones([]);
                setFilteredImportacionesByTienda([]);
            }
        } catch (err) {
            console.error("Error obteniendo importaciones pendientes:", err);
            setImportaciones([]);
            setFilteredImportacionesByTienda([]);
        } finally {
            setImportsLoading(false);
        }
    };

    const fetchPresupuestosAprobados = async (tiendaValue = "") => {
        try {
            setLoadingAprobados(true);
            // Puedes añadir filtros de fecha si lo necesitas
            console.log(tiendaValue ?? 0);
            const res = await api.get(
                `/api/GOI/GetPresupuestosAprobados/${
                    tiendaValue == "" ? 0 : tiendaValue
                }`
            );
            console.log("Respuesta de presupuestos aprobados:", res);
            if (res && res.status === 200 && Array.isArray(res.data)) {
                setPresupuestosAprobados(res.data);
            } else {
                setPresupuestosAprobados([]);
            }
        } catch (err) {
            console.error("Error cargando presupuestos aprobados:", err);
            setPresupuestosAprobados([]);
        } finally {
            setLoadingAprobados(false);
        }
    };

    const handleAprobarReferencias = async (ids = [], importId = null) => {
        if (!ids || ids.length === 0) {
            notificationRef.current?.addNotification(
                "No hay ids para aprobar.",
                "warning"
            );
            return;
        }
        try {
            const payload = { Ids: ids, Aprobar: true };
            const res = await api.post(
                "/api/GOI/Detalle/AprobarReferenciasNuevas",
                payload
            );
            if (res && (res.status === 200 || res.status === 201)) {
                notificationRef.current?.addNotification(
                    "Referencias aprobadas.",
                    "success"
                );

                const importIdToUse = importId || currentImportId;

                // Si disponemos de id de importación: primero forzamos la validación (incluyendo especiales aprobados)
                // y luego refrescamos detalle + resumen para que la tabla se actualice y las referencias aprobadas desaparezcan.
                if (importIdToUse) {
                    try {
                        await api.get(
                            `/api/Presupuestos/importaciones/${importIdToUse}/validacion`,
                            {
                                params: { incluirEspecialesAprobados: true },
                            }
                        );
                    } catch (err) {
                        console.error(
                            "Error desencadenando validación tras aprobar referencias:",
                            err
                        );
                        notificationRef.current?.addNotification(
                            "Se aprobaron referencias pero la revalidación falló.",
                            "warning"
                        );
                    }

                    try {
                        const [detalleResp, resumenResp] = await Promise.all([
                            api.get(
                                `/api/GOI/Importaciones/${importIdToUse}/detalle`
                            ),
                            api.get(
                                `/api/GOI/Importaciones/${importIdToUse}/resumen`
                            ),
                        ]);
                        setDetailContenido({
                            resumen: resumenResp.data,
                            detalle: detalleResp.data,
                        });
                        setCurrentImportId(importIdToUse);
                    } catch (err) {
                        console.error(
                            "Error refrescando detalle/resumen tras aprobar:",
                            err
                        );
                    }
                }

                // refrescar lista de importaciones pendientes siempre que sea posible
                await fetchImportacionesPendientes();
            } else {
                notificationRef.current?.addNotification(
                    "Error aprobando referencias.",
                    "error"
                );
            }
        } catch (err) {
            console.error("Error aprobando referencias:", err);
            const msg = err?.response?.data || "Error al aprobar referencias.";
            notificationRef.current?.addNotification(String(msg), "error");
        }
    };

    // Función para validar si el presupuesto puede ser aprobado
    const validatePresupuestoParaAprobar = (detalle) => {
        if (!Array.isArray(detalle)) {
            return { valid: false, message: "No hay datos para validar." };
        }
        
        // Verificar items con estado "No encontrado" (estado 3)
        const itemsNoEncontrados = detalle.filter(item => {
            const estado = Number(
                item.estado ?? 
                item.Estado ?? 
                item.codEstado ?? 
                item.CodEstado ?? 
                item.EstadoValidacion ?? 
                item.estadoValidacion ?? 
                0
            );
            return estado === 3;
        });
        
        // Verificar items con cantidad a 0 o negativa
        const itemsConCerosCantidad = detalle.filter(item => {
            const cantidad = Number(
                item.cantidad ?? 
                item.Cantidad ?? 
                item.unidad ?? 
                item.Unidad ??
                item.unidades ??
                item.Unidades ??
                0
            );
            return cantidad <= 0;
        });
        
        // Verificar items con precio a 0 o negativo
        const itemsConCerosPrecio = detalle.filter(item => {
            const precio = Number(
                item.precioGOI ?? 
                item.PrecioGOI ?? 
                item.precio ?? 
                item.Precio ??
                item.precioUnitario ??
                item.PrecioUnitario ??
                0
            );
            return precio <= 0;
        });
        
        // Construir mensaje de error
        const errores = [];
        
        if (itemsNoEncontrados.length > 0) {
            errores.push(`${itemsNoEncontrados.length} item(s) con estado "No encontrado"`);
        }
        
        if (itemsConCerosCantidad.length > 0) {
            errores.push(`${itemsConCerosCantidad.length} item(s) con cantidad 0 o negativa`);
        }
        
        if (itemsConCerosPrecio.length > 0) {
            errores.push(`${itemsConCerosPrecio.length} item(s) con precio 0 o negativo`);
        }
        
        if (errores.length > 0) {
            return {
                valid: false,
                message: `No se puede aprobar el presupuesto. Se encontraron: ${errores.join(", ")}. Por favor, corrija estos items antes de aprobar.`,
                details: {
                    noEncontrados: itemsNoEncontrados,
                    cerosCantidad: itemsConCerosCantidad,
                    cerosPrecio: itemsConCerosPrecio
                }
            };
        }
        
        return { valid: true };
    };

    const handleAprobarPresupuesto = async (idImportacion) => {
        if (!idImportacion) {
            notificationRef.current?.addNotification(
                "No hay id de importación para aprobar.",
                "warning"
            );

            return;
        }
        
        // Validar el contenido del presupuesto antes de aprobar
        if (detailContenido?.detalle) {
            const validation = validatePresupuestoParaAprobar(detailContenido.detalle);
            if (!validation.valid) {
                notificationRef.current?.addNotification(
                    validation.message,
                    "error"
                );
                return;
            }
        }
        try {
            // Obtener datos del presupuesto antes de aprobarlo para la notificación
            let nombrePresupuesto = "";
            let codigoTienda = "";
            
            try {
                const resumenRes = await api.get(`/api/GOI/Importaciones/${idImportacion}/resumen`);
                if (resumenRes && resumenRes.data) {
                    // Buscar en las importaciones actuales para obtener más detalles
                    const importacionActual = importaciones.find(imp => 
                        (imp.idImportacion ?? imp.IdImportacion ?? imp.Id ?? imp.id) === idImportacion
                    );
                    
                    if (importacionActual) {
                        // Priorizar nombrePresupuestoGoi, usar archivoNombre como fallback (no nombreTarifaGoi)
                        nombrePresupuesto = importacionActual.nombrePresupuestoGoi || 
                                           importacionActual.archivoNombre || 
                                           importacionActual.ArchivoNombre ||
                                           importacionActual.archivo ||
                                           importacionActual.nombreArchivo ||
                                           "Sin nombre";
                        codigoTienda = importacionActual.codTienda || 
                                       importacionActual.CodTienda || 
                                       importacionActual.codigoTienda ||
                                       selectedTienda || "";
                    }
                }
            } catch (infoErr) {
                console.warn("No se pudo obtener información del presupuesto para la notificación:", infoErr);
            }

            const res = await api.get(
                `/api/Presupuestos/AprobarPresupuesto/${idImportacion}`
            );
            if (res && res.status === 200) {
                notificationRef.current?.addNotification(
                    "Presupuesto aprobado correctamente.",
                    "success"
                );

                // Enviar notificación al proveedor
                await fetchSendNotificationAprobacion(idImportacion, nombrePresupuesto, codigoTienda);

                // refrescar lista de importaciones pendientes
                await fetchImportacionesPendientes();
            } else {
                notificationRef.current?.addNotification(
                    "No se pudo actualizar el estado de aprobación.",
                    "error"
                );
            }
        } catch (err) {
            console.error("Error aprobando presupuesto:", err);
            notificationRef.current?.addNotification(
                "Error actualizando estado de aprobación.",
                "error"
            );
        }
    };

    const handleEliminarPresupuesto = (idImportacion) => {
        if (!idImportacion) {
            notificationRef.current?.addNotification(
                "No se ha podido obtener el ID de la importación.",
                "error"
            );
            return;
        }

        // Abrir popup de confirmación
        setDeleteImportId(idImportacion);
        setIsDeletePopupOpen(true);
    };

    const handleConfirmDelete = async () => {
        if (!deleteImportId) return;

        try {
            setIsGenerating(true);
            const res = await api.delete(
                `/api/Presupuestos/EliminarPresupuesto/${deleteImportId}`
            );
            
            if (res && res.status === 200) {
                notificationRef.current?.addNotification(
                    "Presupuesto eliminado correctamente.",
                    "success"
                );
                
                setIsDetailModalOpen(false);
                
                // Refrescar las listas
                if (viewMode === "importaciones") {
                    fetchImportacionesPendientes();
                } else if (viewMode === "aprobados") {
                    fetchPresupuestosAprobados(selectedTienda);
                }
            } else {
                notificationRef.current?.addNotification(
                    "Error eliminando el presupuesto.",
                    "error"
                );
            }
        } catch (err) {
            console.error("Error eliminando presupuesto:", err);
            let errorMessage = "Error eliminando el presupuesto.";
            
            if (err.response?.status === 404) {
                errorMessage = "Presupuesto no encontrado.";
            } else if (err.response?.status === 403) {
                errorMessage = "No tiene permisos para eliminar este presupuesto.";
            } else if (err.response?.status === 400) {
                errorMessage = err.response.data || "No se ha podido eliminar el presupuesto.";
            }
            
            notificationRef.current?.addNotification(
                errorMessage,
                "error"
            );
        } finally {
            setIsGenerating(false);
            setIsDeletePopupOpen(false);
            setDeleteImportId(null);
        }
    };

    const handleCancelDelete = () => {
        setIsDeletePopupOpen(false);
        setDeleteImportId(null);
    };

    // useEffect para leer parámetro 'view' de URL solo cuando sea necesario
    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const viewFromUrl = urlParams.get('view');
        // Solo cambiar si viene explícitamente 'aprobados' desde notificación
        if (viewFromUrl === 'aprobados') {
            setViewMode('aprobados');
            
            // Limpiar el parámetro 'view' de la URL para evitar que se mantenga
            urlParams.delete('view');
            const newSearch = urlParams.toString();
            const newUrl = `${location.pathname}${newSearch ? `?${newSearch}` : ''}`;
            window.history.replaceState({}, '', newUrl);
        }
        // No tocar el viewMode por defecto si no viene el parámetro
    }, [location.search]);

    useEffect(() => {
        fetchTiendas();
        fetchProveedoresTarifa();
    }, [user]);

    useEffect(() => {
        if (viewMode === "presupuestos") {
            fetchPresupuestos(selectedTienda);
        } else if (viewMode === "aprobados") {
            fetchPresupuestosAprobados(selectedTienda);
        } else {
            fetchImportacionesPendientes();
        }
    }, [user, selectedTienda, viewMode]);

    // Actualizar el filtro por tienda cuando cambie la tienda seleccionada o las importaciones
    useEffect(() => {
        if (viewMode === "importaciones") {
            if (selectedTienda) {
                setFilteredImportacionesByTienda(
                    importaciones.filter(
                        (item) =>
                            String(item.codTienda) === String(selectedTienda)
                    )
                );
            } else {
                setFilteredImportacionesByTienda(importaciones);
            }
        }
    }, [selectedTienda, importaciones, viewMode]);

    // useEffect para poblar las opciones de filtros disponibles
    useEffect(() => {
        if (viewMode === "importaciones") {
            // Extraer proveedores únicos de las importaciones
            const proveedoresUnicos = [
                ...new Set(
                    importaciones.map((item) => item.empresa).filter(Boolean)
                ),
            ];
            setProveedoresDisponibles(proveedoresUnicos);
            
            // Calcular estados disponibles
            const estadosUnicos = [...new Set(importaciones.map(item => {
                const noEncontrados = item.noEncontr ?? 0;
                const total = item.total ?? 0;
                const procesados = (item.coinc ?? 0) + (item.noCoinc ?? 0) + (item.fueraOK ?? 0);
                
                if (noEncontrados === 0) {
                    return "Aceptado";
                } else if (procesados < total) {
                    return "Pendiente de validación";
                } else if (noEncontrados > 0) {
                    return "Con referencias no encontradas";
                } else {
                    return item.estadoValidacion ?? item.Estado ?? "Pendiente";
                }
            }).filter(Boolean))];
            setEstadosDisponibles(estadosUnicos);
        }
    }, [importaciones, viewMode]);

    // useEffect para cargar presupuestos abiertos cuando cambie la tienda o se abra el modal
    useEffect(() => {
        if (isImportModalOpen) {
            fetchPresupuestosAbiertos();
        }
    }, [isImportModalOpen, selectedTiendaModal]);

    const columnsPresupuestos = [
        {
            key: "codigoPresupuesto",
            label: "Código Presupuesto",
            render: (row) =>
                row.CodigoPresupuesto ??
                row.Codigo ??
                row.CodPresupuesto ??
                row.codigoPresupuesto ??
                row.codigo ??
                "-",
        },
        {
            key: "fecha",
            label: "Fecha",
            render: (row) =>
                formatDate(
                    row.Fecha ??
                        row.FechaPresupuesto ??
                        row.fecha ??
                        row.createdAt
                ),
        },
        {
            key: "totalUnidades",
            label: "Total unidades",
            render: (row) =>
                formatNumber(
                    row.TotalUnidades ??
                        row.totalUnidades ??
                        row.total_unidades ??
                        row.TotalItems ??
                        row.totalItems ??
                        0
                ),
        },
        {
            key: "totalImporte",
            label: "Total importe",
            render: (row) =>
                formatNumber(
                    row.TotalImporte ??
                        row.totalImporte ??
                        row.total_importe ??
                        row.TotalAmount ??
                        row.totalAmount ??
                        0
                ),
        },
        {
            key: "acciones",
            label: "Acciones",
            render: (row) => (
                <div style={{ display: "flex", gap: 8 }}>
                    <Button
                        label="Ver detalle"
                        variant="outline"
                        onClick={async () => {
                            try {
                                const cod =
                                    row.CodigoPresupuesto ??
                                    row.Codigo ??
                                    row.CodPresupuesto ??
                                    row.codigo;
                                if (!cod) {
                                    notificationRef.current?.addNotification(
                                        "Código de presupuesto no disponible",
                                        "warning"
                                    );
                                    return;
                                }
                                const res = await api.get(
                                    `/api/Presupuestos/${encodeURIComponent(
                                        cod
                                    )}`
                                );
                                setDetailTitulo(`Presupuesto ${cod}`);
                                setDetailContenido(res.data ?? {});
                                setIsDetailModalOpen(true);
                            } catch (err) {
                                console.error(
                                    "Error obteniendo detalle presupuesto:",
                                    err
                                );
                                notificationRef.current?.addNotification(
                                    "Error obteniendo detalle del presupuesto",
                                    "error"
                                );
                            }
                        }}
                    />
                </div>
            ),
        },
    ];

    const columnsAprobados = [
        {
            key: "codigoTienda",
            label: "Código Tienda",
            render: (r) => {
                const nombre = r.codigoTienda ?? r.codigoTienda ?? "-";
                const cerrada = r.tiendaCerrada ?? false;
                
                return (
                    <span style={{ color: cerrada ? "red" : "inherit" , fontWeight: cerrada ? "bold" : "normal"}}>
                        {nombre}
                        {cerrada && " (Cerrada)"}
                    </span>
                );
            },
        },
        {
            key: "paisTienda",
            label: "País",
            render: (r) => r.paisTienda ?? "-",
        },
        {
            key: "ciudadTienda",
            label: "Ciudad",
            render: (r) => r.ciudadTienda ?? "-",
        },
        {
            key: "nombreTienda",
            label: "Nombre tienda",
            render: (r) => r.nombreTienda ?? r.nombreTienda ?? "-",
        },
        {
            key: "empresa",
            label: "Proveedor",
            render: (r) => r.empresa ?? r.Empresa ?? "-",
        },
        {
            key: "nombreTarifaGoi",
            label: "Tarifa GOI",
            render: (r) => r.nombreTarifaGoi ?? r.nombreTarifaBook ?? "-",
        },
        {
            key: "nombrePresupuestoGoi",
            label: "Presupuesto GOI",
            render: (r) => r.nombrePresupuestoGoi ?? r.nombreTarifaGoi ?? "-",
        },
        {
            key: "fechaSubida",
            label: "Fecha subida",
            render: (r) => formatDate(r.fechaSubida),
        },
        {
            key: "fechaAprobacion",
            label: "Fecha aprobación",
            render: (r) => formatDate(r.fechaAprobacion),
        },
        {
            key: "totalGOI",
            label: "Total GOI",
            render: (r) => `${formatNumber(r.totalGOI)} ${r.simbolo}`,
        },
        {
            key: "usuarioAprobador",
            label: "Usuario aprobador",
            render: (r) => r.usuarioAprobador,
        },
        {
            key: "acciones",
            label: "Acciones",
            render: (r) => {
                const id = r.idImportacion ?? r.IdImportacion ?? r.Id ?? r.id;
                const aprobado = !!(
                    r.aprobado ??
                    r.Aprobado ??
                    r.presupuestoAprobado ??
                    false
                );

                return (
                    <div
                        className="actions-cell"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: 8,
                            width: "100%",
                        }}
                    >
                        <Button
                            label="Ver detalle"
                            variant="outline"
                            onClick={async () => {
                                try {
                                    console.log("ID para detalle:", id);
                                    console.log("ROW para detalle:", r);
                                    const cod = r.idImportacion;
                                    if (!cod) {
                                        notificationRef.current?.addNotification(
                                            "Código de presupuesto no disponible",
                                            "warning"
                                        );
                                        return;
                                    }
                                    const res = await api.get(
                                        `/api/GOI/GetPresupuestoAprobado/${cod}`
                                    );
                                    setDetailPresupuestoTitulo(
                                        `Presupuesto ${r.nombreTarifaGoi}`
                                    );
                                    setDetailPresupuestoContenido(
                                        res.data ?? {}
                                    );
                                    setIsDetailPresupuestoModalOpen(true);
                                } catch (err) {
                                    console.error(
                                        "Error obteniendo detalle presupuesto:",
                                        err
                                    );
                                    notificationRef.current?.addNotification(
                                        "Error obteniendo detalle del presupuesto",
                                        "error"
                                    );
                                }
                            }}
                        />
                        <Button
                            label="Descargar certificado"
                            variant="outline"
                            onClick={async () => {
                                try {
                                    console.log("ID para detalle:", id);
                                    descargarCertificado(id);
                                } catch (err) {
                                    console.error(
                                        "Error descargando certificado:",
                                        err
                                    );
                                    notificationRef.current?.addNotification(
                                        "Error descargando certificado",
                                        "error"
                                    );
                                }
                            }}
                        />
                    </div>
                );
            },
        },
    ];

    const columnsImportaciones = [
        {
            key: "codigoTienda",
            label: "Código tienda",
            render: (r) => {
                const nombre = r.codigoTienda ?? r.codigoTienda ?? "-";
                const cerrada = r.tiendaCerrada ?? false;
                
                return (
                    <span style={{ color: cerrada ? "red" : "inherit" , fontWeight: cerrada ? "bold" : "normal"}}>
                        {nombre}
                        {cerrada && " (Cerrada)"}
                    </span>
                );
            },
        },
                {
            key: "nombreTienda",
            label: "Nombre Tienda",
            render: (r) => r.nombreTienda ?? r.NombreTienda ?? "-",
        },
        {
            key: "paisTienda",
            label: "País",
            render: (r) => r.paisTienda ?? r.PaisTienda ?? "-",
        },
        {
            key: "ciudadTienda",
            label: "Ciudad",
            render: (r) => r.ciudadTienda ?? r.CiudadTienda ?? "-",
        },
        {
            key: "empresa",
            label: "Proveedor",
            render: (r) => r.empresa ?? r.Empresa ?? "-",
        },
        {
            key: "nombrePresupuestoGoi",
            label: "Nombre Presupuesto GOI",
            render: (r) => r.nombrePresupuestoGoi ?? r.nombreTarifaGoi ?? "-",
        },
        {
            key: "FechaImportacion",
            label: "Fecha importación",
            render: (r) =>
                formatDate(
                    r.fechaSubida ?? r.FechaSubida ?? r.fecha ?? r.createdAt
                ),
        },
        {
            key: "Archivo",
            label: "Archivo",
            render: (r) =>
                r.archivoNombre ??
                r.ArchivoNombre ??
                r.archivo ??
                r.nombreArchivo ??
                "-",
        },
        {
            key: "Resumen",
            label: "No encontrados",
            render: (r) =>
                formatNumber(
                    r.noEncontr ??
                        r.NoEncontr ??
                        r.NoEncontrados ??
                        r.noEncontrados ??
                        0
                ),
        },
        {
            key: "EstadoValidacion",
            label: "Estado validación",
            render: (r) => {
                if (!r) return "-";

                const noEncontrados = r.noEncontr ?? 0;
                const total = r.total ?? 0;
                const procesados =
                    (r.coinc ?? 0) + (r.noCoinc ?? 0) + (r.fueraOK ?? 0);

                // Colores según borrador.jsx
                // Nuevo (Validado): verde (#4bb543) => variant="success"
                // Modificado (Pendiente de validación): naranja (#f7b731) => variant="warning"
                let label = "";
                let variant = "default";

                if (noEncontrados === 0) {
                    label = "Aceptado";
                    variant = "success";
                } else if (procesados < total) {
                    label = "Pendiente de validación";
                    variant = "warning";
                } else if (noEncontrados > 0) {
                    label = "Con referencias no encontradas";
                    variant = "danger";
                } else {
                    label = r.estadoValidacion ?? r.Estado ?? "Pendiente";
                }

                return <Badge label={label} variant={variant} />;
            },
        },
        {
            key: "acciones",
            label: "Acciones",
            render: (r) => {
                const id = r.idImportacion ?? r.IdImportacion ?? r.Id ?? r.id;
                const aprobado = !!(
                    r.aprobado ??
                    r.Aprobado ??
                    r.presupuestoAprobado ??
                    false
                );

                return (
                    <div
                        className="actions-cell"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 8,
                            width: "100%",
                            textAlign: "center",
                        }}
                    >
                        <Button
                            label="Ver detalle"
                            variant="outline"
                            onClick={async () => {
                                try {
                                    if (!id) {
                                        notificationRef.current?.addNotification(
                                            "Id de importación no disponible",
                                            "warning"
                                        );
                                        return;
                                    }
                                    const [resDetalle, resResumen] =
                                        await Promise.all([
                                            api.get(
                                                `/api/GOI/Importaciones/${id}/detalle`
                                            ),
                                            api.get(
                                                `/api/GOI/Importaciones/${id}/resumen`
                                            ),
                                        ]);
                                    setCurrentImportId(id);
                                    setDetailTitulo(
                                        `Importación ${id} - Detalle`
                                    );
                                    setDetailContenido({
                                        resumen: resResumen.data,
                                        detalle: resDetalle.data,
                                    });
                                    setIsDetailModalOpen(true);
                                } catch (err) {
                                    console.error(
                                        "Error cargando detalle importación:",
                                        err
                                    );
                                    notificationRef.current?.addNotification(
                                        "Error cargando detalle de importación",
                                        "error"
                                    );
                                }
                            }}
                        />
                    </div>
                );
            },
        },
    ];

    const filteredPresupuestos = useMemo(() => {
        if (!searchTerm) return presupuestos;
        return presupuestos.filter((p) =>
            matchesSearchInObject(p, searchTerm)
        );
    }, [searchTerm, presupuestos]);
    
const filteredAprobados = useMemo(() => {
  // Si tienes un filteredAprobadosByTienda úsalo aquí.
  // Si no existe, deja presupuestosAprobados directamente:
  let filtered = presupuestosAprobados; // o: filteredAprobadosByTienda

  // 1) Aplicar filtro de búsqueda
  if (searchTerm) {
        filtered = filtered.filter((p) => matchesSearchInObject(p, searchTerm));
  }

  // 2) Aplicar filtros de proveedor
  if (filterProveedores.length > 0) {
    filtered = filtered.filter((item) => {
      const proveedor = item.empresa; 
      return filterProveedores.includes(proveedor);
    });
  }

  // 3) Aplicar filtro de tiendas cerradas
  if (filterTiendasCerradas) {
    filtered = filtered.filter((item) => {
      return item.tiendaCerrada;
    });
  }

  if (filterTiendasAbiertas) {
    filtered = filtered.filter((item) => {
      return !item.tiendaCerrada;
    });
  }

  // 4) Aplicar filtros de estado
  if (filterEstados.length > 0) {
    filtered = filtered.filter((item) => {
      const noEncontrados = item.noEncontr ?? 0;
      const total = item.total ?? 0;
      const procesados =
        (item.coinc ?? 0) + (item.noCoinc ?? 0) + (item.fueraOK ?? 0);

      let estadoItem = "";
      if (noEncontrados === 0) {
        estadoItem = "Aceptado";
      } else if (procesados < total) {
        estadoItem = "Pendiente de validación";
      } else if (noEncontrados > 0) {
        estadoItem = "Con referencias no encontradas";
      } else {
        estadoItem = item.estadoValidacion ?? item.Estado ?? "Pendiente";
      }

      return filterEstados.includes(estadoItem);
    });
  }

  return [...filtered].sort((a, b) => {
  const av = a.tiendaCerrada === false ? 0
           : a.tiendaCerrada === true  ? 1
           : 2; // undefined / null / otros => al final

  const bv = b.tiendaCerrada === false ? 0
           : b.tiendaCerrada === true  ? 1
           : 2;

  return av - bv;
});
}, [
    searchTerm, presupuestosAprobados, filterProveedores, filterEstados, filterTiendasCerradas, filterTiendasAbiertas
]);

    const filteredImportaciones = useMemo(() => {
        let filtered = filteredImportacionesByTienda;

        // Aplicar filtro de búsqueda
        if (searchTerm) {
            filtered = filtered.filter((p) =>
                matchesSearchInObject(p, searchTerm)
            );
        }

        // Aplicar filtros de proveedor
        if (filterProveedores.length > 0) {
            filtered = filtered.filter((item) => {
                const proveedor = item.empresa;
                return filterProveedores.includes(proveedor);
            });
        }

        if(filterTiendasCerradas) {
            filtered = filtered.filter((item) => {
                return item.tiendaCerrada;
            });
        }

        if(filterTiendasAbiertas) {
            filtered = filtered.filter((item) => {
                return !item.tiendaCerrada;
            });
        }

        // Aplicar filtros de estado
        if (filterEstados.length > 0) {
            filtered = filtered.filter((item) => {
                const noEncontrados = item.noEncontr ?? 0;
                const total = item.total ?? 0;
                const procesados = (item.coinc ?? 0) + (item.noCoinc ?? 0) + (item.fueraOK ?? 0);
                
                let estadoItem = "";
                if (noEncontrados === 0) {
                    estadoItem = "Aceptado";
                } else if (procesados < total) {
                    estadoItem = "Pendiente de validación";
                } else if (noEncontrados > 0) {
                    estadoItem = "Con referencias no encontradas";
                } else {
                    estadoItem = item.estadoValidacion ?? item.Estado ?? "Pendiente";
                }
                
                return filterEstados.includes(estadoItem);
            });
        }

        return [...filtered].sort((a, b) => {
  const av = a.tiendaCerrada === false ? 0
           : a.tiendaCerrada === true  ? 1
           : 2; // undefined / null / otros => al final

  const bv = b.tiendaCerrada === false ? 0
           : b.tiendaCerrada === true  ? 1
           : 2;

  return av - bv;
});
    }, [searchTerm, filteredImportacionesByTienda, filterProveedores, filterEstados, filterTiendasCerradas, filterTiendasAbiertas]);

    const openImportModal = () => {
        setImportFile(null);
        setImportNombreTarifa("");
        setPresupuestoGOI("");
        setSelectedTiendaModal(selectedTienda || "");
        // Limpiar estados de confirmación previos
        setImportConfirmData(null);
        setIsConfirmPopupOpen(false);
        setIsImportModalOpen(true);
    };

    const closeImportModal = () => {
        setIsImportModalOpen(false);
    };

    // Función para cerrar el popup de confirmación y limpiar estados
    const closeConfirmPopup = async () => {
        // Si hay una importación pendiente, eliminarla del backend
        if (importConfirmData?.idImportacion) {
            try {
                console.log('🗑️ Cancelando importación en backend:', importConfirmData.idImportacion);
                await api.delete(`/api/Presupuestos/EliminarPresupuesto/${importConfirmData.idImportacion}`);
                console.log('✅ Importación cancelada exitosamente del backend');
                
                // Refrescar la lista de importaciones para reflejar la eliminación
                if (viewMode === "importaciones") {
                    await fetchImportacionesPendientes();
                }
            } catch (error) {
                console.error('❌ Error cancelando importación del backend:', error);
                // No mostrar error al usuario ya que es una operación de limpieza
            }
        }
        
        setIsConfirmPopupOpen(false);
        setImportConfirmData(null);
    };

    // Wrapper para manejar el cierre del popup desde los event handlers
    const handleCloseConfirmPopup = () => {
        closeConfirmPopup().catch(console.error);
    };

    // Funciones para el modal de filtros
    const openFilterModal = () => {
        setIsFilterModalOpen(true);
    };

    const closeFilterModal = () => {
        setIsFilterModalOpen(false);
    };

    const handleSearch = (query) => {
        setSearchTerm(query);
        setCurrentPage(1); // Resetear a página 1 cuando se haga una nueva búsqueda
    };

    const handleAcceptFilters = () => {
        closeFilterModal();
        setCurrentPage(1); // Resetear a página 1 cuando se apliquen filtros
    };

    const handleCleanFilters = () => {
        setFilterProveedores([]);
        setFilterEstados([]);
        setFilterTiendasCerradas(false);
        setFilterTiendasAbiertas(false);
        setCurrentPage(1); // Resetear a página 1 cuando se limpien filtros
    };

    const handleSelectProveedor = (proveedorName) => {
        setFilterProveedores((prevSelected) => {
            if (prevSelected.includes(proveedorName)) {
                return prevSelected.filter(
                    (proveedor) => proveedor !== proveedorName
                );
            } else {
                return [...prevSelected, proveedorName];
            }
        });
    };

    const handleSelectEstado = (estadoName) => {
        setFilterEstados((prevSelected) => {
            if (prevSelected.includes(estadoName)) {
                return prevSelected.filter(
                    (estado) => estado !== estadoName
                );
            } else {
                return [...prevSelected, estadoName];
            }
        });
    };

    const handleFileChange = (e) => {
        const f = e.target.files && e.target.files[0];
        setImportFile(f || null);
    };

    // Cargar presupuestos abiertos
    const fetchPresupuestosAbiertos = async () => {
        try {
            const params = {};
            if (selectedTiendaModal) params.codTienda = selectedTiendaModal;
            
            const response = await api.get("/api/Presupuestos/Abiertos", { params });
            const opciones = response.data.map(p => ({
                label: p.nombrePresupuestoGoi || `Presupuesto ${p.idImportacion}`,
                value: p.idImportacion,
                ...p
            }));
            setPresupuestosAbiertos(opciones);
        } catch (error) {
            console.error("Error cargando presupuestos abiertos:", error);
            notificationRef.current?.addNotification(
                "Error cargando presupuestos abiertos",
                "error"
            );
        }
    };

    const handleNombrePresGOIChange = (option) => {
        if (typeof option === 'object' && option.label) {
            setPresupuestoGOI(option.label);
        } else {
            setPresupuestoGOI(option);
        }
    };

    const handleAddPresupuesto = (nombreNuevo) => {
        setPresupuestoGOI(nombreNuevo);
        // Agregar a la lista local para que aparezca en el dropdown
        const nuevaOpcion = {
            label: nombreNuevo,
            value: nombreNuevo,
            nombrePresupuestoGoi: nombreNuevo
        };
        setPresupuestosAbiertos(prev => [nuevaOpcion, ...prev]);
    };

    const handleImport = async () => {
        // Limpiar estados previos de confirmación al iniciar nueva importación
        setImportConfirmData(null);
        setIsConfirmPopupOpen(false);
        
        if (!selectedTiendaModal) {
            notificationRef.current?.addNotification(
                "Selecciona una tienda antes de importar.",
                "warning"
            );
            return;
        }
        if (!importFile) {
            notificationRef.current?.addNotification(
                "Selecciona un archivo para importar.",
                "warning"
            );
            return;
        }

        // Validar si el nombre del presupuesto ya existe en presupuestos generados
        const nombrePresupuestoAImportar = presupuestoGOI || importNombreTarifa;
        console.log('🔍 Validando duplicados:', {
            nombrePresupuestoAImportar,
            presupuestoGOI,
            importNombreTarifa,
            totalPresupuestosAprobados: presupuestosAprobados.length,
            selectedTiendaModal
        });
        
        if (nombrePresupuestoAImportar && nombrePresupuestoAImportar.trim() !== "") {
            // Asegurar que tenemos presupuestos cargados para la tienda seleccionada
            if (presupuestosAprobados.length === 0) {
                console.log('⚠️ No hay presupuestos aprobados cargados, cargando datos...');
                try {
                    await fetchPresupuestosAprobados(selectedTiendaModal);
                } catch (error) {
                    console.error('Error cargando presupuestos aprobados:', error);
                }
            }
            
            const presupuestoExistente = presupuestosAprobados.find(p => {
                const nombreExistente = p.nombrePresupuestoGoi || p.nombreTarifaGoi;
                console.log('🔍 Comparando:', nombrePresupuestoAImportar, 'vs', nombreExistente);
                return nombreExistente && nombreExistente.trim() === nombrePresupuestoAImportar.trim();
            });
            
            if (presupuestoExistente) {
                console.log('❌ DUPLICADO ENCONTRADO:', presupuestoExistente);
                notificationRef.current?.addNotification(
                    "Este presupuesto goi ya ha sido generado",
                    "warning"
                );
                setIsImporting(false); // Asegurar que no quede en estado de importing
                return;
            }
        }
        
        console.log('✅ No se encontraron duplicados, procediendo con la importación');

        try {
            setIsImporting(true);
            const form = new FormData();
            form.append("archivoExcel", importFile);
            const params = { codTienda: selectedTiendaModal };
            if (importNombreTarifa)
                params.nombreTarifaGoi = importNombreTarifa;
            if (presupuestoGOI) params.nombrePresupuestoGoi = presupuestoGOI;
            
            console.log('Parámetros enviados al backend:', params);
            
            const res = await api.post("/api/GOI/ImportarPresupuesto", form, {
                params,
            });

            // Si respuesta 200 y hay referencias ya existentes
            const referenciasYaExistian =
                res?.data?.ReferenciasYaExistian ||
                res?.data?.referenciasYaExistian;
            let importId =
                res?.data?.IdImportacion ??
                res?.data?.idImportacion ??
                res?.data?.Id ??
                res?.data?.id;
            if (!importId) {
                const loc = res?.headers?.location || res?.headers?.Location;
                if (loc) {
                    const m = String(loc).match(/(\d+)(?!.*\d)/);
                    if (m) importId = Number(m[1]);
                }
            }
            if (
                Array.isArray(referenciasYaExistian) &&
                referenciasYaExistian.length > 0 &&
                importId
            ) {
                console.log("🔴 DUPLICADOS DETECTADOS:", referenciasYaExistian);
                console.log("🔴 IMPORT ID:", importId);
                setImportConfirmData({
                    idImportacion: importId,
                    referenciasDuplicadas: referenciasYaExistian,
                });
                setIsConfirmPopupOpen(true);
                console.log("🔴 POPUP STATE SET TO TRUE");
                setIsImporting(false); // Resetear el estado para permitir interacción con el popup
                notificationRef.current?.addNotification(
                    "Se han detectado referencias ya existentes en el presupuesto. Elige una acción.",
                    "warning"
                );
                return;
            }

            notificationRef.current?.addNotification(
                "Importación completada correctamente.",
                "success"
            );

            // Enviar notificación de importación de presupuesto a administradores
            const nombrePresupuestoImportado = presupuestoGOI || importNombreTarifa || "Presupuesto GOI";
            
            // Buscar la tienda correctamente usando todas las posibles propiedades de código
            const tiendaSeleccionada = tiendasRaw.find(t => {
                const codigoTienda = t.codTienda ?? t.CodTienda ?? t.codigo ?? t.Codigo ?? "";
                return String(codigoTienda) === String(selectedTiendaModal);
            });
            
            // Obtener el nombre de la tienda usando todas las posibles propiedades
            let tiendaNombre = "Tienda no especificada";
            if (tiendaSeleccionada) {
                const codigo = tiendaSeleccionada.codigo ?? tiendaSeleccionada.Codigo ?? "";
                const cadena = tiendaSeleccionada.cadena ?? tiendaSeleccionada.Cadena ?? tiendaSeleccionada.nombreTienda ?? tiendaSeleccionada.nombre ?? "";
                const ciudad = tiendaSeleccionada.ciudad ?? "";
                const pais = tiendaSeleccionada.pais ?? "";
                
                tiendaNombre = `${codigo} - ${cadena}`;
                if (ciudad || pais) {
                    tiendaNombre += ` (${[ciudad, pais].filter(Boolean).join(", ")})`;
                }
            }
            
            console.log('🏪 Datos de tienda para notificación:', {
                selectedTiendaModal,
                tiendaSeleccionada,
                tiendaNombre,
                totalTiendasRaw: tiendasRaw.length
            });
            
            await fetchSendNotificationImportacionPresupuesto(nombrePresupuestoImportado, tiendaNombre);

            if (importId) {
                try {
                    await api.get(
                        `/api/Presupuestos/importaciones/${importId}/validacion`,
                        {
                            params: { incluirEspecialesAprobados: true },
                        }
                    );
                    notificationRef.current?.addNotification(
                        "Validación de importación solicitada automáticamente.",
                        "success"
                    );
                } catch (err) {
                    console.error(
                        "Error validando importación automáticamente:",
                        err
                    );
                    notificationRef.current?.addNotification(
                        "La importación se completó pero no se pudo iniciar la validación automática.",
                        "warning"
                    );
                }
            } else {
                notificationRef.current?.addNotification(
                    "No se pudo obtener el id de la importación. Revisa importaciones pendientes.",
                    "warning"
                );
            }

            if (viewMode === "importaciones")
                await fetchImportacionesPendientes();
            else await fetchPresupuestos(selectedTiendaModal);
            setIsImportModalOpen(false);
            // Fin del try principal
        } catch (err) {
            console.error("Error importando presupuesto:", err);
            // Unificar gestión de error duplicadas
            const data = err?.response?.data;
            const mensaje =
                data?.mensaje ||
                data?.Mensaje ||
                "Error importando el presupuesto. Revisa la consola.";
            // Duplicadas en el Excel
            const duplicadasExcel =
                data?.referenciasDuplicadasExcel ||
                data?.ReferenciasDuplicadasExcel;
            // Duplicadas ya existentes en el presupuesto (backend debe devolver referenciasDuplicadasPresupuesto)
            const duplicadasPresupuesto =
                data?.referenciasDuplicadasPresupuesto ||
                data?.ReferenciasDuplicadasPresupuesto;

            if (
                duplicadasExcel &&
                Array.isArray(duplicadasExcel) &&
                duplicadasExcel.length > 0
            ) {
                setDuplicadasModalData(duplicadasExcel);
                setDuplicadasModalOpen(true);
                notificationRef.current?.addNotification(mensaje, "error");
                return;
            }

            if (
                duplicadasPresupuesto &&
                Array.isArray(duplicadasPresupuesto) &&
                duplicadasPresupuesto.length > 0
            ) {
                setImportConfirmData({
                    idImportacion: data?.idImportacion ?? data?.IdImportacion,
                    referenciasDuplicadas: duplicadasPresupuesto,
                });
                setIsConfirmPopupOpen(true);
                setIsImporting(false); // Resetear el estado para permitir interacción con el popup
                notificationRef.current?.addNotification(mensaje, "warning");
                return;
            }

            notificationRef.current?.addNotification(mensaje, "error");
        } finally {
            setIsImporting(false);
        }
    };

    const fetchSendNotificationImportacionPresupuesto = async (nombrePresupuesto, tiendaNombre) => {
        try {
            const api = getApiInstance();
            const formData = new FormData();

            // Mapeo de códigos de empresa a nombres de proveedor
            const empresaNombres = {
                1: "Grupo Atlante",
                2: "Bershka Imagen",
                3: "Bershka Obras",
                4: "Castel",
                5: "Culdesac",
                6: "Dimalnox",
                7: "Kimak",
                8: "Malasa Mexico",
                9: "Malasa",
                87: "TestEmpresa",
            };

            // Obtener nombre del proveedor
            const codEmpresa = user?.codEmpresa ?? user?.CodEmpresa ?? "";
            const nombreProveedor = empresaNombres[codEmpresa] || "Proveedor desconocido";

            // Crear título y mensaje de la notificación
            const titulo = `Nuevo presupuesto GOI importado por ${nombreProveedor}`;
            const mensaje = `Presupuesto: ${nombrePresupuesto} | Tienda: ${tiendaNombre}`;

            // Enviar notificación a administradores (tipo 1 = Admin)
            formData.append("DestinatariosNotificacion", 1);
            formData.append("CodUsuarioNotifica", user.codUsuario);
            formData.append("Mensaje", mensaje);
            formData.append("Titulo", titulo);
            formData.append("TipoNotificacion", 0); // Info
            
            // Enlace para navegar a la gestión de presupuestos
            const enlace = "/admin/presupuestos?activeTab=presupuestosProveedor";
            formData.append("Enlace", enlace);

            await api.post(`/api/Notificaciones`, formData);
        } catch (error) {
            console.error("Error enviando notificación de importación de presupuesto:", error);
        }
    };

    const fetchProveedoresTarifa = async () => {
        try {
            const api = getApiInstance();
            console.log("Llamando a /api/GOI/Tarifas");
            const response = await api.get("/api/GOI/Tarifas");
            console.log("Respuesta de proveedores:", response.data);
            setTarifas(
                response.data.map((x) => ({
                    label: x.nombreTarifaGoi,
                    value: x.nombreTarifaGoi,
                })) || []
            );
        } catch (error) {
            console.error("Error al obtener proveedores de tarifa:", error);
            notificationRef.current?.addNotification(
                "Error al cargar proveedores",
                "error"
            );
        }
    };

    // Función para aplicar la decisión del usuario sobre duplicadas
    const handleDecisionImportacion = async (modo) => {
        if (!importConfirmData?.idImportacion) return;
        try {
            const api = getApiInstance();
            await api.post(
                "/api/Presupuestos/AplicarDecisionImportacionPresupuesto",
                {
                    IdImportacion: importConfirmData.idImportacion,
                    Modo: modo,
                }
            );
            // Refrescar datos tras aplicar decisión
            await fetchImportacionesPendientes();
            setIsImportModalOpen(false);
            setIsConfirmPopupOpen(false);
            setImportConfirmData(null);
            notificationRef.current?.addNotification(
                "Decisión aplicada correctamente",
                "success"
            );
        } catch (error) {
            notificationRef.current?.addNotification(
                "Error al aplicar decisión",
                "error"
            );
        }
    };

    // Handlers para cada acción del popup
    const handleSoloNuevas = async () => {
        await handleDecisionImportacion("solonuevas");
    };
    const handleActualizar = async () => {
        await handleDecisionImportacion("actualizar");
    };
    const handleSobrescribirPresupuesto = async () => {
        await handleDecisionImportacion("sobrescribirpresupuesto");
    };

    // Manejador para selección de tienda en el modal
    const handleTiendaModalSelect = (opt) => {
        if (!opt) {
            setSelectedTiendaModal("");
            return;
        }
        if (typeof opt === "string") {
            setSelectedTiendaModal(opt);
            return;
        }
        if (opt.value !== undefined && opt.value !== null) {
            setSelectedTiendaModal(String(opt.value));
            return;
        }
        if (opt.CodTienda || opt.Codigo || opt.codigo) {
            setSelectedTiendaModal(
                String(opt.CodTienda ?? opt.Codigo ?? opt.codigo)
            );
            return;
        }
        setSelectedTiendaModal("");
    };

    // Maneja la selección del dropdown: puede venir como objeto { value } o como string (cuando se escribe)
    const handleTiendaSelect = (opt) => {
        if (!opt) {
            setSelectedTienda("");
            return;
        }
        if (typeof opt === "string") {
            setSelectedTienda(opt);
            return;
        }
        if (opt.value !== undefined && opt.value !== null) {
            setSelectedTienda(String(opt.value));
            return;
        }
        if (opt.CodTienda || opt.Codigo || opt.codigo) {
            setSelectedTienda(
                String(opt.CodTienda ?? opt.Codigo ?? opt.codigo)
            );
            return;
        }
        setSelectedTienda("");
    };

    const descargarCertificado = async (idImportacion) => {
        try {
            const response = await api.get(
                `api/GOI/GetCertificadoPresupuesto`,
                {
                    params: { idImportacion }, // enviamos el parámetro
                    responseType: "blob", // importante para recibir el archivo binario
                }
            );

            // Crear un objeto URL para el blob
            const url = window.URL.createObjectURL(new Blob([response.data]));

            const contentDisposition = response.headers["content-disposition"];
            let fileName = `Certificado_GOI_${idImportacion}.pdf`;

            if (contentDisposition) {
                // Primero intenta filename* (UTF-8)
                const utf8Match = contentDisposition.match(
                    /filename\*\=UTF-8''([^;]+)/
                );
                if (utf8Match && utf8Match[1]) {
                    fileName = decodeURIComponent(utf8Match[1]);
                } else {
                    // Si no existe, usa filename normal
                    const match =
                        contentDisposition.match(/filename="?([^"]+)"?/);
                    if (match && match[1]) {
                        fileName = match[1];
                    }
                }
            }

            // Crear un enlace temporal para descargar el archivo
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName); // nombre del archivo
            document.body.appendChild(link);
            link.click();

            // Limpiar el objeto URL
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error al descargar el certificado:", error);
            notificationRef.current?.addNotification(
                "Error al descargar el certificado.",
                "error"
            );
        }
    };

    useEffect(() => {
        setTiendasAbiertas(tiendasRaw.filter((t) => !t.fechaCierre).map(x=>x.codTienda));
    }, [tiendasRaw]);

    const handleSelectTiendasCerradas = () => {
        if(filterTiendasCerradas){
            setFilterTiendasCerradas(false)
        } else {
            if(filterTiendasAbiertas){
                setFilterTiendasAbiertas(false)
            }
            setFilterTiendasCerradas(true)
        }
    }

    const handleSelectTiendasAbiertas = () => {
        if(filterTiendasAbiertas){
            setFilterTiendasAbiertas(false)
        } else {
            if(filterTiendasCerradas){
                setFilterTiendasCerradas(false)
            }
            setFilterTiendasAbiertas(true)
        }
    }

    return (
        <div className="presupuestos-proveedor">
            <div
                className="dashboard-usuarios__content__table-header"
                style={{
                    marginBottom: 12,
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                }}
            >
                {/* Buscar ocupa el espacio sobrante */}
                <div style={{ flex: 1, minWidth: 0, marginRight: 12 }}>
                    <InputSearch
                        context="tableSearch"
                        placeholder="Buscar..."
                        onSearch={handleSearch}
                    />
                </div>

                {/* Selector de tienda pegado a los botones */}
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <div style={{ width: "260px" }}>
                        <InputDropdown
                            options={tiendasOptions}
                            onSelect={handleTiendaSelect}
                            placeholder="Seleccionar tienda"
                            showLabel={false}
                            hasSearch={true}
                            value={
                                tiendasOptions.find(
                                    (o) =>
                                        String(o.value) ===
                                        String(selectedTienda)
                                ) ||
                                (selectedTienda
                                    ? {
                                          label: selectedTienda,
                                          value: selectedTienda,
                                      }
                                    : "")
                            }
                        />
                    </div>

                    {/* Botones de acción pegados al selector */}
                            <Button
                                label="Filtros"
                                onClick={openFilterModal}
                                icon={<FiFilter />}
                            />
                    {(() => {
                        const codTipoEmpresa =
                            user?.CodTipoEmpresa ??
                            user?.codTipoEmpresa ??
                            user?.empresa?.CodTipoEmpresa ??
                            user?.empresa?.codTipoEmpresa ??
                            null;
                        return codTipoEmpresa === 3 ? (
                            <Button
                                label="Importar presupuesto"
                                icon={<IoCloudUpload />}
                                variant="filled"
                                onClick={openImportModal}
                            />
                        ) : null;
                    })()}
                    <Button
                        label="Presupuestos abiertos"
                        variant={
                            viewMode === "importaciones" ? "filled" : "outline"
                        }
                        onClick={() => setViewMode("importaciones")}
                    />
                    <Button
                        label="Presupuestos generados"
                        variant={
                            viewMode === "aprobados" ? "filled" : "outline"
                        }
                        onClick={() => setViewMode("aprobados")}
                    />
                </div>
            </div>

            {viewMode === "importaciones" ? (
                importsLoading ? (
                    <div>Cargando importaciones...</div>
                ) : (
                    <TableEditable
                        rowKey={"idImportacion"}
                        data={filteredImportaciones}
                        columns={columnsImportaciones}
                        noResultsMessage="No hay importaciones pendientes."
                        showHeaderCheckbox={false}
                        currentPage={currentPage}
                        onPageChange={setCurrentPage}
                        resetPaginationOnDataChange={false}
                    />
                )
            ) : viewMode === "aprobados" ? (
                loadingAprobados ? (
                    <div>Cargando presupuestos aprobados...</div>
                ) : (
                    <TableEditable
                        rowKey={"idImportacion"}
                        data={filteredAprobados}
                        columns={columnsAprobados}
                        noResultsMessage="No hay presupuestos aprobados."
                        showHeaderCheckbox={false}
                        currentPage={currentPage}
                        onPageChange={setCurrentPage}
                        resetPaginationOnDataChange={false}
                    />
                )
            ) : (
                <Table
                    key={`presupuestos-${presupuestos.length}-${filteredPresupuestos.length}`}
                    data={filteredPresupuestos}
                    columns={columnsPresupuestos}
                    noResultsMessage={
                        loading
                            ? "Cargando..."
                            : "No se han encontrado presupuestos."
                    }
                    showHeaderCheckbox={false}
                    currentPage={currentPage}
                    onPageChange={setCurrentPage}
                    resetPaginationOnDataChange={false}
                />
            )}

            {/* Modal para referencias duplicadas en el Excel */}
            {duplicadasModalOpen && (
                <Modal
                    title="Referencias duplicadas en el Excel"
                    isOpen={duplicadasModalOpen}
                    onClose={() => setDuplicadasModalOpen(false)}
                    outlineButtonLabel="Cerrar"
                    hideFooter={true}
                >
                    <div>
                        <p
                            style={{
                                marginBottom: 16,
                                fontSize: "1.1rem",
                                color: "#b26a00",
                                fontWeight: 500,
                                background: "#fffbe6",
                                borderRadius: 6,
                                padding: "12px 16px",
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                            }}
                        >
                            <PiWarning
                                style={{
                                    fontSize: 22,
                                    marginRight: 8,
                                    color: "#b26a00",
                                }}
                            />
                            El archivo contiene referencias duplicadas. Revisa
                            el Excel antes de volver a importarlo.
                        </p>
                        <table
                            style={{
                                width: "100%",
                                borderCollapse: "collapse",
                            }}
                        >
                            <thead>
                                <tr>
                                    <th
                                        style={{
                                            textAlign: "left",
                                            borderBottom: "1px solid #eee",
                                            padding: "4px 8px",
                                        }}
                                    >
                                        Referencia
                                    </th>
                                    <th
                                        style={{
                                            textAlign: "left",
                                            borderBottom: "1px solid #eee",
                                            padding: "4px 8px",
                                        }}
                                    >
                                        Repeticiones
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {duplicadasModalData.map((item) => (
                                    <tr key={item.referencia}>
                                        <td style={{ padding: "4px 8px" }}>
                                            {item.referencia}
                                        </td>
                                        <td style={{ padding: "4px 8px" }}>
                                            {item.repeticiones}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Modal>
            )}

            <Notification ref={notificationRef} />

            <Modal
                title="Importar presupuesto"
                isOpen={isImportModalOpen}
                onClose={closeImportModal}
                onCancel={closeImportModal}
                onAccept={handleImport}
                primaryButtonLabel={isImporting ? "Importando..." : "Importar"}
                outlineButtonLabel="Cancelar"
                className="modal--centered"
            >
                <div className="dashboard-productos__modal">
                    <form
                        className="dashboard-productos__modal__content"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleImport();
                        }}
                    >
                        {!importFile ? (
                            <Input
                                type="file"
                                label="Archivo Excel"
                                name="archivoExcel"
                                onChange={handleFileChange}
                            />
                        ) : (
                            <FileList
                                files={[importFile]}
                                handleDelete={(file) => setImportFile(null)}
                            />
                        )}

                          <InputDropdown
                            options={tiendasOptions.filter(x=> tiendasAbiertas.includes(x.value))}
                            onSelect={handleTiendaModalSelect}
                            placeholder="Seleccionar tienda"
                            label="Seleccionar tienda"
                            hasSearch={true}
                            value={
                                tiendasOptions.filter(x=> tiendasAbiertas.includes(x.value)).find(
                                    (o) =>
                                        String(o.value) ===
                                        String(selectedTiendaModal)
                                ) ||
                                (tiendasAbiertas.includes(selectedTiendaModal)
                                    ? {
                                          label: selectedTiendaModal,
                                          value: selectedTiendaModal,
                                      }
                                    : "")
                            }
                        />

                        <InputDropdownAdd
                            options={presupuestosAbiertos}
                            onSelect={handleNombrePresGOIChange}
                            onAddOption={handleAddPresupuesto}
                            value={presupuestoGOI}
                            label="Nombre presupuesto GOI"
                            placeholder="Buscar o crear presupuesto GOI"
                        />

                        <InputDropdown
                            options={tarifas}
                            onSelect={(e) => setImportNombreTarifa(e.label)}
                            label="Nombre tarifa GOI"
                            placeholder="Seleccione tarifa GOI"
                        />
                        <p style={{ fontSize: 12, color: "#666" }}>
                            El presupuesto se importará para la tienda seleccionada.
                        </p>
                    </form>
                </div>
            </Modal>

            <Modal
                title={detailTitulo}
                isOpen={isDetailModalOpen}
                onClose={() => setIsDetailModalOpen(false)}
                outlineButtonLabel="Cerrar"
                className="modal--centered modal--large"
            >
                {detailContenido?.detalle &&
                    Array.isArray(detailContenido.detalle) && (
                        <>
                            {/*Información de resumen */}
                            {detailContenido?.resumen && (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "8px 0",
                                        borderBottom: "1px solid #eee",
                                        marginBottom: "8px",
                                        fontSize: "14px",
                                        color: "#666",
                                    }}
                                >
                                    {/* Datos a la izquierda */}
                                    <div>
                                        {(() => {
                                            // Si resumen es array (como viene del endpoint)
                                            if (
                                                Array.isArray(
                                                    detailContenido.resumen
                                                )
                                            ) {
                                                const totalRegistros =
                                                    detailContenido.resumen.reduce(
                                                        (sum, item) =>
                                                            sum +
                                                            (item.total ?? 0),
                                                        0
                                                    );
                                                const noEncontrados =
                                                    detailContenido.resumen.find(
                                                        (item) =>
                                                            item.estado === 3
                                                    )?.total ?? 0;
                                                return `Total registros: ${formatNumber(
                                                    totalRegistros
                                                )} | No encontrados: ${formatNumber(
                                                    noEncontrados
                                                )}`;
                                            }
                                            // Si resumen es objeto (fallback para compatibilidad)
                                            return `Total registros: ${formatNumber(
                                                detailContenido.resumen.Total ??
                                                    0
                                            )} | No encontrados: ${formatNumber(
                                                detailContenido.resumen
                                                    .NoEncontrados ??
                                                    detalleNoEncontrado.length
                                            )}`;
                                        })()}
                                    </div>

                                    {/* Botones a la derecha */}
                                    <div style={{ display: "flex", gap: 8 }}>
                                        {user.codEmpresa === 1 && (() => {
                                            const validation = detailContenido?.detalle ? 
                                                validatePresupuestoParaAprobar(detailContenido.detalle) : 
                                                { valid: false, message: "No hay datos de detalle disponibles" };
                                            
                                            return (
                                                <Button
                                                    label={validation.valid ? "Aprobar presupuesto" : "No se puede aprobar"}
                                                    variant={validation.valid ? "filled" : "outline"}
                                                    disabled={!validation.valid}
                                                    onClick={async () => {
                                                        if (validation.valid) {
                                                            handleAprobarPresupuesto(
                                                                currentImportId
                                                            );
                                                        }
                                                    }}
                                                    style={{ 
                                                        marginBottom: 8,
                                                        opacity: validation.valid ? 1 : 0.6,
                                                        cursor: validation.valid ? "pointer" : "not-allowed"
                                                    }}
                                                    title={!validation.valid ? validation.message : ""}
                                                />
                                            );
                                        })()}
                                        
                                        {/* Botón eliminar - para proveedores en vista de importaciones */}
                                        {(() => {
                                            const isProveedor = user?.codEmpresa === 3 || 
                                                              user?.codEmpresa === 7 || 
                                                              user?.CodTipoEmpresa === 3 || 
                                                              user?.empresa?.CodTipoEmpresa === 3;
                                            const isImportacionesView = viewMode === "importaciones";
                                            
                                            if (isProveedor && isImportacionesView) {
                                                return (
                                                    <Button
                                                        label="Eliminar presupuesto"
                                                        variant="outline"
                                                        statusType="error"
                                                        onClick={() => {
                                                            if (currentImportId) {
                                                                handleEliminarPresupuesto(currentImportId);
                                                            }
                                                        }}
                                                        style={{ 
                                                            marginBottom: 8
                                                        }}
                                                    />
                                                );
                                            }
                                            return null;
                                        })()}
                                    </div>
                                </div>
                            )}

                            {/* ✅ Tabla que ocupa todo el espacio restante */}
                            <TableEditable
                                showHeaderCheckbox={false}
                                onRowSelect={(selected) =>
                                    setSeleccionados(selected)
                                }
                                data={detailContenido.detalle}
                                columns={[
                                    {
                                        key: "referencia",
                                        label: "Referencia",
                                        render: (r) => (
                                            <div
                                                title={
                                                    r.referencia ??
                                                    r.referenciaBook ??
                                                    "-"
                                                }
                                                style={{
                                                    maxWidth: "100%",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}
                                            >
                                                {r.referencia ??
                                                    r.referenciaBook ??
                                                    "-"}
                                            </div>
                                        ),
                                    },
                                    {
                                        key: "codEstado",
                                        label: "Estado",
                                        render: (r) => {
                                            const e =
                                                r.codEstado ??
                                                r.codEstado ??
                                                null;
                                            return (
                                                <Badge
                                                    label={
                                                        estadoLabels[e] ?? "-"
                                                    }
                                                    variant={estadoVariant(e)}
                                                />
                                            );
                                        },
                                    },
                                    {
                                        key: "unidades",
                                        label: "Cantidad",
                                        render: (r) =>
                                            formatNumber(
                                                r.cantidad ??
                                                    r.Cantidad ??
                                                    r.unidad ??
                                                    0
                                            ),
                                    },
                                    {
                                        key: "precioGOI",
                                        label: "Precio GOI",
                                        render: (r) =>
                                            formatNumber(
                                                r.precioGOI ??
                                                    0
                                            ) + ` ${r.simbolo || ""}`,
                                    },
                                    {
                                        key: "unidad",
                                        label: "Unidad GOI",
                                        render: (r) =>
                                            r.unidad ?? r.unidad ?? "-",
                                    },
                                    {
                                        key: "total",
                                        label: "Total",
                                        render: (r) => {
                                            const cantidad = Number(
                                                r.cantidad ??
                                                    r.Cantidad ??
                                                    r.unidad ??
                                                    0
                                            ) || 0;
                                            const precio = Number(
                                                r.precioGOI ??
                                                    0
                                            ) || 0;
                                            const total = cantidad * precio;
                                            return formatNumber(total);
                                        },
                                    },
                                ]}
                                rowKey="idDetalle"
                                noResultsMessage="No hay elementos para mostrar."
                            />
                            <div
                                style={{
                                    marginTop: 12,
                                    padding: "8px 12px",
                                    borderTop: "1px solid #eee",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    fontSize: 14,
                                    color: "#333",
                                    background: "#fafafa",
                                    borderRadius: 6,
                                }}
                            >
                                <div>{`Items: ${detailContenido.detalle.length}`}</div>
                                <div style={{ fontWeight: 600 }}>
                                    {(() => {
                                        const total = detailContenido.detalle.reduce(
                                            (acc, it) => {
                                                const qty = Number(
                                                    it.cantidad ??
                                                        it.Cantidad ??
                                                        it.unidad ??
                                                        0
                                                ) || 0;
                                                const price = Number(
                                                    it.precioGOI ?? 0
                                                ) || 0;
                                                return acc + qty * price;
                                            },
                                            0
                                        );
                                        const simbolo =
                                            detailContenido.detalle.find(
                                                (r) => r && r.simbolo
                                            )?.simbolo ?? "";
                                        return `Total presupuesto: ${formatNumber(
                                            total
                                        )}${simbolo ? ` ${simbolo}` : ""}`;
                                    })()}
                                </div>
                            </div>
                        </>
                    )}
                {!detailContenido?.detalle && (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                            color: "#666",
                        }}
                    >
                        <p>No hay información para mostrar.</p>
                    </div>
                )}
            </Modal>

            <Modal
                title={detailPresupuestoTitulo}
                isOpen={isDetailPresupuestoModalOpen}
                onClose={() => setIsDetailPresupuestoModalOpen(false)}
                outlineButtonLabel="Cerrar"
                className="modal--centered modal--large"
            >
                {detailPresupuestoContenido &&
                    Array.isArray(detailPresupuestoContenido) && (
                        <>
                            <TableEditable
                                showHeaderCheckbox={false}
                                onRowSelect={(selected) =>
                                    setSeleccionados(selected)
                                }
                                data={detailPresupuestoContenido}
                                columns={[
                                    {
                                        key: "referencia",
                                        label: "Referencia",
                                        render: (r) => (
                                            <div
                                                title={
                                                    r.referencia ??
                                                    r.referenciaBook ??
                                                    "-"
                                                }
                                                style={{
                                                    maxWidth: "100%",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}
                                            >
                                                {r.referencia ??
                                                    r.referenciaBook ??
                                                    "-"}
                                            </div>
                                        ),
                                    },
                                    {
                                        key: "unidades",
                                        label: "Cantidad",
                                        render: (r) =>
                                            formatNumber(
                                                r.cantidad ??
                                                    r.Cantidad ??
                                                    r.unidad ??
                                                    0
                                            ),
                                    },
                                    {
                                        key: "precioGOI",
                                        label: "Precio GOI",
                                        render: (r) =>
                                            formatNumber(
                                                r.precioGOI ??
                                                    0
                                            ) + ` ${r.simbolo}`,
                                    },
                                    {
                                        key: "unidad",
                                        label: "Unidad GOI",
                                        render: (r) =>
                                            r.unidad == ""
                                                ? "-"
                                                : r.unidad ?? r.unidad ?? "-",
                                    },
                                    {
                                        key: "total",
                                        label: "Total",
                                        render: (r) => {
                                            const cantidad = Number(
                                                r.cantidad ??
                                                    r.Cantidad ??
                                                    r.unidades ??
                                                    r.Unidades ??
                                                    0
                                            ) || 0;
                                            const precio = Number(
                                                r.precioGOI ??
                                                    0
                                            ) || 0;
                                            const total = cantidad * precio;
                                            return `${formatNumber(total)} ${r.simbolo || ""}`;
                                        },
                                    },
                                ]}
                                rowKey="idDetalle"
                                noResultsMessage="No hay elementos 'No encontrados' pendientes de aprobación."
                            />
                            <div
                                style={{
                                    marginTop: 12,
                                    padding: "8px 12px",
                                    borderTop: "1px solid #eee",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    fontSize: 14,
                                    color: "#333",
                                    background: "#fafafa",
                                    borderRadius: 6,
                                }}
                            >
                                <div>{`Items: ${detailPresupuestoContenido.length}`}</div>
                                <div style={{ fontWeight: 600 }}>
                                    {(() => {
                                        const total =
                                            detailPresupuestoContenido.reduce(
                                                (acc, it) => {
                                                    const qty =
                                                        Number(
                                                            it.cantidad ??
                                                                it.Cantidad ??
                                                                it.unidades ??
                                                                it.Unidades ??
                                                                0
                                                        ) || 0;
                                                    const price =
                                                        Number(
                                                            it.precioGOI ??
                                                                0
                                                        ) || 0;
                                                    return acc + qty * price;
                                                },
                                                0
                                            );
                                        const simbolo =
                                            detailPresupuestoContenido.find(
                                                (r) =>
                                                    r &&
                                                    (r.simbolo || r.Simbolo)
                                            )?.simbolo ??
                                            detailPresupuestoContenido.find(
                                                (r) =>
                                                    r &&
                                                    (r.simbolo || r.Simbolo)
                                            )?.Simbolo ??
                                            "";
                                        return `Total presupuesto: ${formatNumber(
                                            total
                                        )}${simbolo ? ` ${simbolo}` : ""}`;
                                    })()}
                                </div>
                            </div>
                        </>
                    )}
                {!detailPresupuestoContenido && (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                            color: "#666",
                        }}
                    >
                        <p>No hay información para mostrar.</p>
                    </div>
                )}
            </Modal>

            {/* Popup personalizado para decisión de referencias duplicadas */}
            {console.log(
                "🔵 RENDERING POPUP, isConfirmPopupOpen:",
                isConfirmPopupOpen,
                "importConfirmData:",
                importConfirmData
            )}
            {isConfirmPopupOpen && (
                <div
                    className="popup-overlay-custom"
                    onClick={handleCloseConfirmPopup}
                >
                    <div
                        className="popup-decision-custom"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="popup-decision-custom__header">
                            <div className="popup-decision-custom__title">
                                <PiWarning className="popup-decision-custom__icon" />
                                <h3>Referencias duplicadas</h3>
                            </div>
                            <button
                                className="popup-decision-custom__close"
                                onClick={handleCloseConfirmPopup}
                            >
                                <IoMdClose />
                            </button>
                        </div>

                        <div className="popup-decision-custom__content">
                            <p className="popup-decision-custom__message">
                                Se han encontrado referencias que ya estaban
                                cargadas.
                                <br />
                                <br />
                                <b>Referencias detectadas:</b>
                                <ul
                                    style={{
                                        margin: "8px 0 0 0",
                                        paddingLeft: 18,
                                        fontSize: "1rem",
                                        color: "#b26a00",
                                    }}
                                >
                                    {importConfirmData?.referenciasDuplicadas?.map(
                                        (ref, index) => (
                                            <li
                                                key={
                                                    typeof ref === "string"
                                                        ? ref
                                                        : ref.referencia ||
                                                          index
                                                }
                                                style={{ marginBottom: 2 }}
                                            >
                                                {typeof ref === "string"
                                                    ? ref
                                                    : ref.referencia}
                                            </li>
                                        )
                                    )}
                                </ul>
                                <br />
                                ¿Qué acción deseas realizar?
                            </p>
                        </div>

                        <div className="popup-decision-custom__actions">
                            <Button
                                label="Cancelar"
                                variant="outline"
                                onClick={handleCloseConfirmPopup}
                                fullWidth="width-100"
                            />
                            <Button
                                label="Añadir solo nuevas"
                                variant="filled"
                                onClick={handleSoloNuevas}
                                fullWidth="width-100"
                                statusType="success"
                            />
                            <Button
                                label="Actualizar referencias existentes y añadir nuevas"
                                variant="filled"
                                onClick={handleActualizar}
                                fullWidth="width-100"
                                statusType="info"
                            />
                            <Button
                                label="Sobrescribir presupuesto (las referencias ya aprobadas no se pueden eliminar)"
                                variant="filled"
                                onClick={handleSobrescribirPresupuesto}
                                fullWidth="width-100"
                                statusType="error"
                            />
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de filtros */}
            <Modal
                title="Filtros"
                isOpen={isFilterModalOpen}
                onClose={closeFilterModal}
                onAccept={handleAcceptFilters}
                outlineButtonLabel="Limpiar"
                primaryButtonLabel={`Ver resultados (${filteredImportaciones.length})`}
                onCancel={handleCleanFilters}
            >
                <div className="section-header__modal__section">
                    {user.codTipoEmpresa === 1 || user.CodTipoEmpresa === 2 ? (
                    <Accordion title="Proveedor">
                        <ul className="section-header__modal__section__content">
                            {proveedoresDisponibles.map((proveedor, index) => (
                                <Tag
                                    key={index}
                                    label={proveedor}
                                    isSelected={filterProveedores.includes(
                                        proveedor
                                    )}
                                    onSelect={handleSelectProveedor}
                                />
                            ))}
                        </ul>
                    </Accordion>
                    ) : null}
                    <Accordion title="Estado tienda">
                        <Tag 
                            key ="estadoLabel"
                            label="Tiendas cerradas (C)"
                            isSelected={filterTiendasCerradas}
                            onSelect={handleSelectTiendasCerradas}
                        />      
                         <Tag
                                    key="estadoLabel"
                                    label="Tiendas abiertas"
                                    isSelected={filterTiendasAbiertas}
                                    onSelect={handleSelectTiendasAbiertas}
                                  />
                    </Accordion>
                    <Accordion title="Estado">
                        <ul className="section-header__modal__section__content">
                            {estadosDisponibles.map((estado, index) => (
                                <Tag
                                    key={index}
                                    label={estado}
                                    isSelected={filterEstados.includes(
                                        estado
                                    )}
                                    onSelect={handleSelectEstado}
                                />
                            ))}
                        </ul>
                    </Accordion>
                </div>
            </Modal>

            {/* Popup de confirmación para eliminar presupuesto */}
            {isDeletePopupOpen && (
                <Popup
                    type="alert"
                    alertType="warning"
                    titleMessage="Confirmar eliminación"
                    alertMessage="¿Está seguro de que desea eliminar este presupuesto? Esta acción no se puede deshacer."
                    onConfirm={handleConfirmDelete}
                    onClose={handleCancelDelete}
                    confirmLabel="Eliminar"
                    cancelLabel="Cancelar"
                />
            )}
        </div>
    );
}
